<template>
  <el-table
    v-loading="isLoading"
    :data="data"
    border
    stripe
  >
    <el-table-column
      v-for="data in columnList"
      :key="data.type"
      :prop="data.type"
      :label="data.title || $t(`table.${data.type}`)"
      v-bind="data.custom"
    >
      <template #default="{ row }">
        <!-- Localized content -->
        <div v-if="data.isLocalized">
          <div
            v-for="lang in getLanguageList(row, data.type)"
            :key="`${data.type}-${lang.key}`"
          >
            <div v-if="row[`${data.type}${lang.suffix}`]">
              <span class="language-key">{{ lang.key }}</span>
              <template v-if="data.type !== 'terms'">
                {{ row[`${data.type}${lang.suffix}`] }}
              </template>
              <div
                v-else
                v-html="row[`${data.type}${lang.suffix}`]"
              />
            </div>
          </div>
        </div>
        <!-- Localized content -->

        <!-- Category / Brands -->
        <div v-else-if="data.type === 'category_slugs' || data.type === 'brand_slugs'">
          <div
            v-for="slug in row[data.type]"
            :key="`${data.type}-${slug}`"
            class="category-item"
          >
            {{ slug }}
          </div>
        </div>
        <!-- Category / Brands -->

        <div v-else-if="data.type === 'currently_discounted'">
          <template v-if="row[data.type].length === 2">
            All
          </template>
          <template v-else>
            {{ row[data.type].join(',') }}
          </template>
        </div>

        <!-- Action -->
        <div
          v-else-if="data.type === 'action'"
          class="button-group"
        >
          <el-button
            size="mini"
            type="warning"
            icon="el-icon-edit"
            circle
            @click="handleEditButtonClick(row)"
          />
        </div>
        <!-- Action -->

        <!-- Others -->
        <div v-else>
          {{ row[data.type] }}
        </div>
        <!-- Others -->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { promoTagListColumns as columnList } from '../../../const/promo-tag'
import { getLanguageList } from '../../../utils/form'

export default {
  name: 'PromoCodeListTable',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      columnList,
      selectedStoreId: null,
    }
  },
  methods: {
    handleEdit() {
      const store = this.stores.find(s => s.id === this.selectedStoreId)
      const params = { store }
      this.$router.push({ name: 'PromotionCodeDetail', params })
    },
    handleEditButtonClick({ id }) {
      this.$emit('edit', id)
    },
    getLanguageList,
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

.language-key {
  font-weight: bold;
}

.category-item {
  display: inline-block;
  border-radius: 4px;
  padding: 0px 6px;
  margin: 4px 1px;
  color: #333;
  background-color: rgba(144, 147, 153, 0.1);
  border: 1px solid rgba(144, 147, 153, 0.2);
}
</style>
